module.exports = __webpack_public_path__ + "static/sekelwa-52f3eb886a42ac1f0157b27cd21977a6.jpg";